if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};

/* ── Product description Read more / Read less toggle ── */
(function () {
  function initDescriptionToggles() {
    document.querySelectorAll('[data-desc-toggle]').forEach(function (btn) {
      var targetId = btn.getAttribute('aria-controls');
      var target = document.getElementById(targetId);
      if (!target) return;

      /* Measure collapsed height (~3 lines) */
      var style = window.getComputedStyle(target);
      var lh = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.6;
      var collapsedHeight = Math.ceil(lh * 3) + 4;
      var fullHeight = target.scrollHeight;

      /* Only collapse if content meaningfully exceeds 3 lines */
      if (fullHeight <= collapsedHeight + 8) {
        btn.style.display = 'none';
        return;
      }

      /* Set up initial collapsed state via inline style for smooth JS animation */
      target.style.maxHeight = collapsedHeight + 'px';
      target.style.overflow = 'hidden';
      target.style.transition = 'max-height 0.52s cubic-bezier(0.16, 1, 0.3, 1)';
      target.classList.add('product__description-content--collapsed');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = btn.dataset.seeMore || 'Read more';

      var isCollapsed = true;

      btn.addEventListener('click', function () {
        if (isCollapsed) {
          /* Expand — animate to full height */
          fullHeight = target.scrollHeight; /* re-measure in case content changed */
          target.style.maxHeight = fullHeight + 'px';
          target.classList.remove('product__description-content--collapsed');
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = btn.dataset.showLess || 'Read less';
          isCollapsed = false;

          /* After transition completes, release max-height so content can reflow freely */
          target.addEventListener('transitionend', function onExpandEnd() {
            if (!isCollapsed) target.style.maxHeight = 'none';
            target.removeEventListener('transitionend', onExpandEnd);
          });
        } else {
          /* Collapse — pin current height first, then animate down */
          target.style.maxHeight = target.scrollHeight + 'px';
          /* Force layout reflow before starting transition */
          target.offsetHeight; // eslint-disable-line no-unused-expressions
          target.style.maxHeight = collapsedHeight + 'px';
          target.classList.add('product__description-content--collapsed');
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = btn.dataset.seeMore || 'Read more';
          isCollapsed = true;
        }
      });
    });
  }

  function init() {
    initDescriptionToggles();
  }

  /* Wait for fonts to load for accurate line-height measurement */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { init(); });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

